import { ajax } from '../../utils/ajax-handler';
import { get } from '../../utils/object-helpers';
import storeEvent from '../../utils/store-event';
import Cart from './cart-v1';

const CART_VERSION = 1;
const CLS = {
    fadeOut: 'fade-out'
};
const SERVICE_TIMEOUT = 8000;
const IMAGE_TIMEOUT = 4000; // Needs to be less than SERVICE_TIMEOUT
const AJAX_TIMEOUT = 8000;

export default class {
    init() {
        this.state = {
            open: false,
            cart: null,
            spinnerFadeOutClass: '',
            renderSpinner: true,
            closeDialogText: '',
            errorMessage: ''
        };
        this.resp = null;
    }
    onCreate(input) {
        this.defaultErrorMessage = get(input, 'page.info.content.defaultErrorMessage', '');
        this.csrfToken = get(input, 'config.csrfToken', '') || get(input, 'page.info.tokens.csrfToken', '');
        this.ajaxPath = get(input, 'config.ajaxPath', '');
        this.pageId = get(input, 'config.pageId', '');
        this.init();
    }
    onInput(input) {
        return {
            cartVersion: CART_VERSION,
            spinnerText: get(input, 'page.modules.LOADING_SPINNER_MODULE.accessibilityText', '')
        };
    }
    onMount() {
        storeEvent.openAddToCart.listen(async data => {
            this.openDialog();
            try {
                this.state.closeDialogText = data.closeDialogText;
                this.resp = await this.fetchAddToCart(data);
                this.updateAddToCart();
            } catch (err) {
                this.resp = null;
                this.showError();
            }
        });
    }
    openDialog() {
        this.state.open = true;

        // If image doesn't load, check if service sent content.
        this.imageTimeoutId = setTimeout(() => {
            if (this.state.cart) {
                this.fadeOutSpinner();
            }
        }, IMAGE_TIMEOUT);

        // If service doesn't load, then show error message.
        this.serviceTimeoutId = setTimeout(() => {
            this.fadeOutSpinner();
            if (!this.state.cart) {
                this.resp = null;
                this.showError();
            }
        }, SERVICE_TIMEOUT);
    }
    closeDialog() {
        clearTimeout(this.imageTimeoutId);
        clearTimeout(this.serviceTimeoutId);
        this.init();
    }
    updateAddToCart() {
        if (this.resp) {
            this.state.cart = Cart.build(this.resp, this.defaultErrorMessage);
        }
    }
    onHeroImageLoad() {
        if (this.state.cart) {
            this.fadeOutSpinner();
        }
    }
    showError() {
        this.state.errorMessage = this.defaultErrorMessage;
    }
    fadeOutSpinner() {
        clearTimeout(this.imageTimeoutId);
        clearTimeout(this.serviceTimeoutId);
        this.state.spinnerFadeOutClass = CLS.fadeOut;
    }
    removeSpinner() {
        this.state.renderSpinner = false;
    }
    fetchAddToCart(data) {
        return new Promise((resolve, reject) => {
            const ajaxUrl = buildAddToCartUrl(this.ajaxPath, data.itemId, data.variationId, data.quantity);
            ajax({ url: ajaxUrl, csrfToken: this.csrfToken, pageId: this.pageId }, {
                successCallBack: response => {
                    resolve(response);
                },
                errorCallBack: error => {
                    reject(error);
                }
            }, AJAX_TIMEOUT);
        });
    }
}

export function buildAddToCartUrl(ajaxPath, itemId, variationId, quantity) {
    if (!ajaxPath || !itemId) {
        return;
    }
    const url = new URL(ajaxPath, window.location.origin);
    url.searchParams.append('item_id', itemId);

    const qty = quantity && quantity !== -1 ? quantity : 1;
    url.searchParams.append('quantity', qty);

    if (variationId && variationId !== -1) {
        url.searchParams.append('variation_id', variationId);
    }

    return url.href;
}
